// @package
import * as React from "react";
import * as R from "ramda";
import { Col, Row, Glyphicon } from "react-bootstrap";
import { connect } from "react-redux";
import { REQUEST } from "src/co/sura/config/ajax-wrapper";
import { DotLoader } from "react-spinners";
import { Mensaje } from "../../../general/componentes/Mensaje";
import { enviar, descargarPlantillaMasivo } from "../modulos/actions";
import ModalConfirmacion from "../../../general/componentes/ModalConfirmacion";


class CargarParametros extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.renderPestañaEstadoEnvio = this.renderPestañaEstadoEnvio.bind(this);
        this.renderPestañaEstadoCarga = this.renderPestañaEstadoCarga.bind(this);
        this.validarXLS = this.validarXLS.bind(this);

        this.state = {
            show: false,
            fileUpload: React.createRef(),
            archivo: null,
            archivoCorrecto: false,
            estadoCarga: REQUEST.NONE,
            modalConfirmarVisible: false
        };

        this.mostrarModal = this.mostrarModal.bind(this);

    }

    mostrarModal(modalConfirmarVisible: boolean) {
        this.setState({ modalConfirmarVisible });
    }

    render() {
        const { estadoEnvio, mensajeUsuario } = this.props;
        const { modalConfirmarVisible } = this.state;

        return (
            <div>
                <Row>

                    <h1 className={"title"}>Carga de parámetros de agrupadoras</h1>
                    <div className={"card"}>
                        <div className={"card-header"}>
                            <h3 className={"panel-title"}>Cargar parámetros</h3>
                        </div>
                        <div className={"card-body"}>
                            <Row className={"form-group"}>
                                <Col sm={10}>
                                    <span>En esta opción podrás cargar los datos de las empresas agrupadoras que se han identificado y también las
                                                     actividades económicas de manejo especial.</span>

                                </Col>
                            </Row>
                        </div>
                        <div className={"card-body"} style={{ marginTop: '30px' }}>
                            <Row className={"form-group"}>
                                <Col sm={3}>
                                    <a className="btns btn-success" onClick={this.descargarPlantillaXLS}>
                                        <b>Plantilla Excel</b> &nbsp;<Glyphicon className={"download-alt"} glyph={"download-alt"} />
                                    </a>
                                </Col>
                                <Col sm={3}>
                                    <a className="btns btn-primary" onClick={this.cargarArchivoXLS} >
                                        <input type="file" ref={this.state.fileUpload} name="archivo"
                                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" style={{ display: "none" }} />
                                        <b>Cargar Excel</b> &nbsp;<Glyphicon className={"upload"} glyph={"upload"} />
                                    </a>
                                </Col>
                                <Col smOffset={2} sm={1}>
                                    <button type="button" className="btns btns-link" onClick={this.limpiar}
                                        disabled={!this.state.archivoCorrecto}>
                                        Limpiar
                                                    </button>
                                </Col>
                                <Col sm={2}>
                                    <button className="btns btns-primary" style={{ width: '142px' }} onClick={() => this.mostrarModal(true)} disabled={!this.state.archivoCorrecto}>
                                        <b>Enviar</b> &nbsp;<Glyphicon className={"glyphicon-play"} glyph={"glyphicon-play"} />
                                    </button>
                                </Col>

                                {modalConfirmarVisible && (

                                    <ModalConfirmacion titulo={"Confirmar Envío"} show={this.state.modalConfirmarVisible}
                                        onAceptar={this.confirmar}
                                        onCancelar={() => this.mostrarModal(false)}>
                                        ¿Seguro que desea enviar el archivo?
                                    </ModalConfirmacion>

                                )}

                            </Row>
                        </div>
                    </div>

                </Row>
                <Row>
                    {this.renderPestañaEstadoEnvio(estadoEnvio, mensajeUsuario)}
                    {this.renderPestañaEstadoCarga()}
                </Row>
            </div>
        );
    }

    renderPestañaEstadoEnvio(estado: REQUEST, mensajeUsuario: string) {
        switch (estado) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={mensajeUsuario ? mensajeUsuario : "Error, revisar el formato como se indica en la plantilla!"} />;
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                    </div>
                );
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <Mensaje type={"success"} mensaje={" Se realizó la carga de la información exitosamente, se encuentra en proceso de envío."} />
                    </span>
                );
            default:
                return false;
        }
    }

    renderPestañaEstadoCarga() {
        switch (this.state.estadoCarga) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={" El archivo no se cargó porque no cumple con el tamaño de 1 Megabytes."} />;
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                    </div>
                );
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <Mensaje type={"success"} mensaje={" El archivo se cargó con exito."} />
                    </span>
                );
            default:
                return false;
        }
    }

    enviar = () => {
        if (this.state.archivoCorrecto) {
            this.props.dispatch(enviar(this.state.archivo));
        }
        this.resetFile();
    }

    limpiar = () => {
        this.resetFile();
        this.mostrarModal(false);
    }

    resetFile = () => {
        this.setState({
            estadoCarga: REQUEST.NONE,
            archivo: null,
            archivoCorrecto: false
        });
    }

    cargarArchivoXLS = () => {
        const fileUpload = this.state.fileUpload.current;
        fileUpload.value = null;
        fileUpload.click();
        fileUpload.onchange = (e) => {
            this.validarXLS(e.target.files[0]);
        };   
    }

    validarXLS(file: File) {
        if (file) {
            const nombre = file.name;
            const extencion = nombre.substring(nombre.length - 4, nombre.length);
            const tamano = file.size;
            if (extencion !== "xlsx" || tamano > 1000000) {
                this.setState({
                    estadoCarga: REQUEST.ERROR,
                    archivo: null,
                    archivoCorrecto: false
                });
                return;
            }
            this.setState({
                estadoCarga: REQUEST.SUCCESS,
                archivo: file,
                archivoCorrecto: true
            });
        }
    }

    confirmar = () => {
        this.mostrarModal(false);
        this.enviar();
        
    }

    descargarPlantillaXLS = () => {
        this.props.dispatch(descargarPlantillaMasivo());
    }

}


export default connect((store: any) => {
    return {
        estadoEnvio: R.pathOr([], ["estructura_agrupadoras", "estadoEnvio"])(store),
        mensajeUsuario: R.pathOr(undefined, ["estructura_agrupadoras", "mensajeUsuario"])(store)
    };
})(CargarParametros);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/parametros/cargar_parametros/componentes/Cargar.tsx